export const paymentDetails = [
    { label: "شماره حساب:", value: "1001002003848" },
    { label: "شماره شبا:", value: "IR340610000001001002003848" },
]